var map = {
	"./bg.png": "./src/assets/login/bg.png",
	"./big-logo.png": "./src/assets/login/big-logo.png",
	"./logo.png": "./src/assets/login/logo.png",
	"./normal.png": "./src/assets/login/normal.png",
	"./select.png": "./src/assets/login/select.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/login sync recursive ^\\.\\/.*\\.png$";